import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BasketService } from '@core/services/basket/basket.service';
import { GtmService } from '@core/services/gtm/gtm.service';
import { SettingsService } from '@core/services/settings.service';
import { ReserveInStoreService } from '@features/reserve-in-store/reserve-in-store.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { AsyncPipe } from '@angular/common';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { RouterLink } from '@angular/router';
import { BadgeComponent } from '@shared/badge/badge.component';
import { MoreThanPipe } from '@features/navigation/pipes/more-than.pipe';

@UntilDestroy()
@Component({
    selector: 'app-header-basket-link',
    templateUrl: './header-basket-link.component.html',
    styleUrls: ['./header-basket-link.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, SvgIconComponent, AsyncPipe, TranslateSafePipe, BadgeComponent, MoreThanPipe]
})
export class HeaderBasketLinkComponent implements OnInit {
    totalProductsCount$: Observable<number>;

    constructor(
        private basketService: BasketService,
        private reserveInStoreService: ReserveInStoreService,
        public settingsService: SettingsService,
        public gtmService: GtmService
    ) {}

    ngOnInit(): void {
        this.totalProductsCount$ = combineLatest([
            this.basketService.basketData$,
            this.reserveInStoreService.reserveInStore$
        ]).pipe(
            map(([basket, store]) => [basket?.basket?.totalProductsCount || 0, store?.totalProductsCount || 0]),
            map(([basketCount, storeCount]) => basketCount + storeCount),
            untilDestroyed(this)
        );
    }
}
